import './App.css';
import FBCAnalytics from './firebase/FBCAnalytics';
import BasicInfo from './firebase/BasicInfo';
import { BrowserRouter as Router, Switch, Route, Routes } from 'react-router-dom';
import Home from './pages'
import Legal from './pages/legal'
import Contact from './pages/contact'
import Questions from './pages/questions'

function App() {


  return (

    <div>
      <Router>
        <Routes>
          <Route path='/'exact element={<Home/>} />
          <Route path='/contact'exact element={<Contact/>} />
          <Route path='/questions'exact element={<Questions/>} />
          <Route path='/legal'exact element={<Legal/>} />
        </Routes>
      </Router>


      <div className="App">
        <BasicInfo/>
        <FBCAnalytics title={"Getting started"} message={"Site is being visited"}/>
        </div>
    </div>
    


  );
}

export default App;
